


































































import {
    Vue,
    Component,
    Prop,
} from 'vue-property-decorator';
import Modal from '@/components/Modal.vue';
import Icon from '@/components/Icon.vue';
import Spinner from '@/atomics/loaders/Spinner.vue';
import DidsInfoTable from '@/components/queue/DidsInfoTable.vue';
import idealName from '@/utils/ideal-name';
import capitalize from '@/utils/text';
import { urlApi } from '@/utils/url';
import fetchDidsInfo, { DidRow } from '@/api/dids';

interface DidInfo {
    did: string;
    queue_name: string;
}

@Component({
    components: {
        Modal,
        Icon,
        Spinner,
        DidsInfoTable,
    },
})
export default class ModalQueueDids extends Vue {
    @Prop(String) readonly name!: string;

    @Prop(Number) readonly customerId!: number;

    dids: string[] = [];

    rows: DidRow[] = [];

    isLoading = false;

    error = '';

    get queueDisplayName(): string {
        const queue = this.$store.getters.getQueueByName(this.name);
        return queue?.metadata?.name || capitalize(idealName(this.name));
    }

    openModal() {
        (this.$refs.modal as Modal).toogleModal();
        this.fetchDids();
    }

    closeModal() {
        (this.$refs.modal as Modal).toogleModal();
    }

    async fetchDids() {
        this.isLoading = true;
        this.error = '';
        this.dids = [];
        this.rows = [];

        try {
            const url = `${urlApi}/queues/dids`;
            const token = sessionStorage.getItem('token') || '';

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    customerId: this.customerId,
                    queueNames: [idealName(this.name)],
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(`Error ${response.status}: ${JSON.stringify(data)}`);
            }

            // La respuesta puede venir en varios formatos:
            // 1. {"7001": ["3584181596"]} - objeto con queue name como key
            // 2. Array de objetos con { did, queue_name }
            // 3. { dids: [...] }
            const queueName = idealName(this.name);
            if (data[queueName] && Array.isArray(data[queueName])) {
                this.dids = data[queueName];
            } else if (Array.isArray(data)) {
                this.dids = data.map((item: DidInfo | string) => {
                    if (typeof item === 'string') return item;
                    return item.did;
                });
            } else if (data.dids) {
                this.dids = data.dids;
            }

            await this.buildRows();
        } catch (err) {
            this.error = `Error: ${(err as Error).message}`;
        } finally {
            this.isLoading = false;
        }
    }

    async buildRows() {
        // Inicializa filas con medio/producto vacíos para no romper la lista
        // de DIDs si el endpoint de info falla.
        this.rows = this.dids.map((did) => ({ did, medio: null, producto: null }));

        if (this.dids.length === 0) return;

        try {
            const info = await fetchDidsInfo(this.dids);
            this.rows = this.dids.map((did) => ({
                did,
                medio: info[did]?.medio ?? null,
                producto: info[did]?.producto ?? null,
            }));
        } catch {
            // Datos de medio/producto no disponibles: se mantiene la tabla
            // con esos campos vacíos.
        }
    }
}
